/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForThreatResourceActiveRefresh extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForThreatResourceActiveRefresh");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForThreatResourceActiveRefresh.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForThreatResourceActiveRefresh>): BackgroundJobPayloadForThreatResourceActiveRefresh {
        let obj = Object.assign(new BackgroundJobPayloadForThreatResourceActiveRefresh(), model);
        BackgroundJobPayloadForThreatResourceActiveRefresh.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForThreatResourceActiveRefresh>): BackgroundJobPayloadForThreatResourceActiveRefresh {
        if (!model) return null;
        return BackgroundJobPayloadForThreatResourceActiveRefresh.newInstance(<BackgroundJobPayloadForThreatResourceActiveRefresh> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForThreatResourceActiveRefresh) {
        if (!obj) return;

        models.BackgroundJobPayloadForThreatResourceActiveRefresh.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForThreatResourceActiveRefresh): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForThreatResourceActiveRefresh.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
